export { default as NWatermark, watermarkProps } from './src/Watermark';
